<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e6RMCf/tc-custom/9780545231954.jpg?1728851645847" alt="This image is the cover for the book Road of the Dead"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Road of the Dead
      </h1>
      <p class="bookDescription body article font2">
        <b>“Peopled with singular protagonists and downright scary villains, this bleak-yet-romantic tale is a whirlwind ride for the right reader.” —<i>Publishers Weekly</i> (starred review)</b><br/><br/>On a storm-ravaged night, a nineteen-year-old girl is kidnapped, raped, and killed. Three days later, her two younger brothers set out in search of her murderer. Cole, seventeen, is a dark-eyed devil who doesn’t care if he lives or dies, while Ruben, fourteen, is a strange child who sometimes, inexplicably, experiences sensations above and beyond his own. This is the story of the boys’ journey from their half-Roma home on a London junk lot to the ghostly moors of Devon, where they hope and fear to find the truth about their sister’s death. It’s a long road, cold and hard and violent. It’s <i>The Road of the Dead</i>.<br/><br/><b>“Fans of Brooks’s <i>Martyn Pig, Kissing the Rain, Candy </i>and <i>Lucas</i>, won’t be disappointed by this thrilling, gritty story and it’s memorable, heart-breaking characters.” —<i>Kirkus Reviews</i></b><br/><br/><b>“Brooks’s feel for mood and setting is as masterful here as in his taut, noir Martyn Pig. A haunting, tense drama builds from the first line and only lets up for scenes of brutal, vivid violence that bring readers back down to earth.” —<i>School Library Journal</i></b><br/><br/><b>“Brooks succeeds on every level with this enthralling mystery/thriller that will keep readers turning pages well past bedtime. The descriptions are poetic, and the dialogue is lyrical but realistic.” —<i>Horn Book</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Brooks
      </h2>
      
      <p class="authorDescription body article"> Kevin Brooks is the groundbreaking author of the internationally acclaimed novels DAWN; BLACK RABBIT SUMMER; BEING; THE ROAD OF THE DEAD, a Mystery Writers of America "Edgar" nominee; CANDY; KISSING THE RAIN; LUCAS; and MARTYN PIG, which received England's Branford Boase Award for Best First Novel. Brooks lives in Yorkshire, England. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34ebc749